import {
  getWeekDay,
  getWeekdayWithId,
} from "../../../helpers/utils/calendar.util";
import { SchedulerLesson } from "../../../models/schedule/lesson";
import { SchedulerViewModeBase } from "./SchedulerViewModeBase";

/**
 * ViewMode to display a full week from Monday to Friday even though the lessons array does not start at Monday
 * Do not use with tailed schedules (no lessons added before the start of the vacancy)
 */
export class ViewModeFullWeek extends SchedulerViewModeBase {
  private offset = 0;
  private lessonLength = 0;

  getWeekday(
    startDate: Date,
    day: number,
  ): { id: number; name: string; shortName: string } {
    if (this.lessonLength >= 5) {
      if (day < this.offset) day += 5 - this.offset;
      else day -= this.offset;
    }

    return getWeekdayWithId(startDate, day);
  }

  toggleActive(
    day: number,
    duration: number,
    lessons: SchedulerLesson[][],
  ): SchedulerLesson[] {
    if (this.isReadOnly) {
      return [];
    }

    if (this.lessonLength >= 5) {
      if (day < this.offset) day += 5 - this.offset;
      else day -= this.offset;
    }

    const newLessons: SchedulerLesson[] = [];
    const lesson = lessons[day][duration];
    for (let i = day; i < lessons.length; i += 5) {
      newLessons.push({ ...lessons[i][duration], isActive: !lesson.isActive });
    }
    return newLessons;
  }

  setDay(
    day: number,
    value: boolean,
    lessons: SchedulerLesson[][],
  ): SchedulerLesson[] {
    if (this.isReadOnly) {
      return [];
    }

    if (this.lessonLength >= 5) {
      if (day < this.offset) day += 5 - this.offset;
      else day -= this.offset;
    }

    const newLessons: SchedulerLesson[] = [];
    for (let i = day; i < lessons.length; i += 5) {
      for (let j = 0; j < lessons[i].length; j++) {
        const lesson = lessons[i][j];
        newLessons.push({ ...lesson, isActive: value && !!lesson.canActivate });
      }
    }

    return newLessons;
  }

  displayLessons(
    startDate: Date,
    lessons: SchedulerLesson[][],
    page = 0,
  ): SchedulerLesson[][] {
    const start = getWeekDay(startDate).id;
    this.offset = start;
    this.lessonLength = lessons.length;
    const weekLessons = [];

    if (lessons.length < 5) return lessons;

    for (let i = 0; i < 5; i++) {
      if (i < start && lessons[i + 5]) weekLessons.push(lessons[i + 5]);
      else weekLessons.push(lessons[i]);
    }
    return weekLessons;
  }

  hasPage(page: number, lessons: SchedulerLesson[][]): boolean {
    return false;
  }
}
